module.exports = __webpack_public_path__ + "img/12.9c466d90.jpg";